import { createApp } from "vue";
import axios from 'axios';
import VueAxios from 'vue-axios';
import App from "./App.vue";
import UtmHelper from "./helpers/UtmHelper.js"

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.js"
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas);
import { fab } from '@fortawesome/free-brands-svg-icons';
library.add(fab);
import { far } from '@fortawesome/free-regular-svg-icons';
library.add(far);
import { dom } from "@fortawesome/fontawesome-svg-core";
dom.watch();

createApp(App, { location: window.DEALER_LOCATION })
    .component("font-awesome-icon", FontAwesomeIcon)
    .use(VueAxios, axios)
    .mount("#app");

// Let the document know when the mouse is being used
document.body.addEventListener('mousedown', function () {
    document.body.classList.add('using-mouse');
});

// Re-enable focus styling when Tab is pressed
document.body.addEventListener('keydown', function (event) {
    if (event.keyCode === 9) {
        document.body.classList.remove('using-mouse');
    }
});

// Initialize Utm Helper functionality
new UtmHelper();
